
import styled from 'styled-components';
import { Flyer } from '../components/Flyer';
import { Section } from './Section';
import { SecondarySection } from '../components/SecondarySection';
import { useDocument } from '../hooks/useDocument';
import { doc, DocumentReference, CollectionReference } from '../firebase';

type Order = string[];

interface CommonData {
	order: Order;
}

const defaultCommonData: CommonData = {
	order: []
};

interface LocalizedData {
	heading: string;
	subheading: string;
}

const defaultLocalizedData: LocalizedData = {
	heading: '',
	subheading: ''
};
interface Props {
	res: {
		base: DocumentReference;
		localized: DocumentReference;
		items: CollectionReference;
	};
	className?: string;
}

const Container = styled.div`
	padding-top: 80px;
`;

const Flyers = styled.div`
	display: grid;
	grid-gap: 24px;
	grid-template-columns: repeat(3, 1fr);
`;

export const Power = ({ res, className }: Props) => {
	const { data: common } = useDocument<CommonData>(res.base, defaultCommonData);
	const { data: localized } = useDocument<LocalizedData>(res.localized, defaultLocalizedData);

	return <Container id="zasilanie" className={className}>
		<Section heading={localized.heading}>
			<SecondarySection heading={localized.subheading}>
				<Flyers>
					{common.order.map((id: string) => {
						const base = doc(res.items, id);
						return <Flyer key={id} res={{ base, localized: doc(base, 'localized/pl-PL') }} />
					})}
				</Flyers>
			</SecondarySection>
		</Section>
	</Container >
};